import { useState, useContext } from "react";
import { useMutation, useQuery } from "react-query";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContext } from "../../../../../hooks/context";
import {
  getMenuCategoriesList,
  orderMenuCategoryList,
  getPaymentGateways,
} from "../../../../../services/inventory";
import { pathConstants } from "../../../../../routes/pathContants";
import { useGetViewStorefrontDetail } from "../../../../../hooks/api/queries";

export const useCreateFoodMenu = () => {
  const navigate = useNavigate();
  const [menuStage, setMenuStage] = useState("Storefront Details");
  const [sortMenuCategories, setSortMenuCategories] = useState([]);
  const [selectedMenuItems, setSelectedMenuItems] = useState({});
  const [selectedPricingType, setSelectedPricingType] = useState("");
  const triggerToast = useContext(ToastContext);
  const { menuId } = useParams();

  const { data: dataPaymentMethods } = useQuery(
    ["payment-gateways"],
    () => getPaymentGateways().then((res) => res.data?.data),
    { staleTime: Infinity },
  );

  const { data: menuProperties, isLoading: isFetchingMenuProperties } =
    useGetViewStorefrontDetail(menuId);

  const { isLoading: isLoadingSortCategories, mutate: mutateSortCategories } =
    useMutation({
      mutationFn: (data) => orderMenuCategoryList({ id: menuId, data }),
      onSuccess: () => {
        refetchMenuCategories();
        triggerToast("Categories sorted successfully", "success");
        if (menuId) {
          navigate(-1);
        } else {
          if (dataPaymentMethods && dataPaymentMethods.length > 0) {
            navigate(pathConstants.INVENTORY_MENU);
          } else {
            setMenuStage("Payment Setup");
          }
        }
      },
      onError: (error) => {
        triggerToast(`${error.response.data.message}`, "warning");
      },
    });

  const {
    isLoading: isFetchingMenuCategories,
    refetch: refetchMenuCategories,
  } = useQuery(
    ["getMenuCategoriesList", [menuId]],
    () =>
      getMenuCategoriesList({ id: menuId }).then((res) =>
        setSortMenuCategories(res?.data?.data),
      ),
    {
      enabled: menuId ? true : false,
    },
  );

  return {
    selectedMenuItems,
    isFetchingMenuCategories,
    isLoadingSortCategories,
    menuProperties,
    menuId,
    menuStage,
    sortMenuCategories,
    selectedPricingType,
    isFetchingMenuProperties,
    setSelectedPricingType,
    setSelectedMenuItems,
    setMenuStage,
    setSortMenuCategories,
    mutateSortCategories,
  };
};
